<template>
    <div :data-userid="userInfo ? userInfo.userId : ''">
        <div class="flexLayout" style="padding: 14px 18px 0;" :data-userid="userInfo ? userInfo.id : ''">
            <div style="width: 80px;">
                <div class="imageArea circle hiddenOverflow" style="height: 80px; border: solid 1px #BBBBBB;"
                    :data-headerImg="userInfo ? userInfo.headerImg : ''">
                    <img class="fullSpace cover" :src="userInfo.headerImg" v-if="userInfo && userInfo.headerImg"/>
                </div>
            </div>
            <div class="marginL16 flexItem">
                <div class="font12r" style="padding-top:  12px;">
                    {{ userInfo ? userInfo.userName : '' }}
                    <span class="textLabel roleLabel alignM">
                        <template v-if="userInfo && userInfo.level==1">初级代理商</template>
                        <template v-if="userInfo && userInfo.level==2">中级代理商</template>
                        <template v-if="userInfo && userInfo.level==3">高级代理商</template>
                    </span>
                </div>
                <!--                        <div class="font14r" style="margin-top: 16px;">-->
                <!--                            合作截止时间：2022-xx-xx-->
                <!--                        </div>-->
                <div class="font14r marginT16 greyADAAAA">
                    有效期：
                    {{ userInfo ? formatDate(userInfo.createTime) : '' }}
                </div>
<!--                <div class="font14r marginT16">-->
<!--                    过期日期：{{ userInfo ? formatDate(userInfo.expireTime) : '' }}-->
<!--                </div>-->
            </div>
        </div>
        <div class="font14r clearfix" style="padding: 0 12px 0 30px; margin-top: 33px; line-height: 35px;">
            <span>费用余额：{{ userInfo ? userInfo.balance : '??' }}元</span>
            <router-link class="floatR orange2" :to="{ name:'agencyRecharge'}">
                <span class="orange2" >去充值</span>
                &gt;
            </router-link>
        </div>
    </div>
</template>

<script>
import modulePart from "@comp/part/modulePart";
export default {
    name: "agencyPersonalHeader",
    extends : modulePart,
    props : {
        userInfo : Object
    }
}
</script>

<style scoped>

.roleLabel {
    padding: 0 8px;
    height: 27px;
    line-height: 27px;
    font-size: 14px;
    text-align: center;
    background: transparent;
    border: solid 1px #BBBBBB;
    color: #101010;
}
.orange2 {
    color: #E99D42;
}
.greyADAAAA {
    color: #ADAAAA;
}
</style>